import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@heroui/react"
import { CheckboxCircle } from "@/components/icons/CheckboxCircle"
import { getRouteApi, useNavigate } from "@tanstack/react-router"
import { asSearchString } from "@repo/utils/search-params"
import BridgeHelper from "@/utils/rn-bridge/bridge-helper"
import { NavCode } from "@/utils/rn-bridge/nav-code"

export type ResultSuccessSearch = {
  title?: string;
  type?: string;
  end?: string;
  op?: string;
  redirect?: string;
  action?: string;
};

export const Route = createFileRoute("/result/success")({
  validateSearch: (search: Record<string, unknown>): ResultSuccessSearch => ({
    title: asSearchString(search.title),
    type: asSearchString(search.type),
    end: asSearchString(search.end),
    op: asSearchString(search.op),
    redirect: asSearchString(search.redirect),
    action: asSearchString(search.action),
  }),
  component: ResultSuccess,
});


const routeApi = getRouteApi("/result/success")

export default function ResultSuccess() {
    const navigate = useNavigate()
    const search = routeApi.useSearch()
    const title = search.title ?? "操作成功"
    const end = search.end ?? "true"
    const op = search.op ?? "返回帮助中心"
    const redirect = search.redirect ?? "/help"
    const action = search.action

    const handleAction = () => {
        if (action === "close_webview") {
            BridgeHelper.sendMessage({
                nav_code: NavCode.CLOSE_WEBVIEW,
            })
            return
        }
        if (end === "true") {
            navigate({ href: redirect, replace: true })
            return
        }
        navigate({ href: redirect })
    }

    return (
        <div className={"min-h-screen flex flex-col items-center justify-center"}>
            <CheckboxCircle className="w-24 h-24 text-green-500 animate-success" />
            <div className={"m-12 text-2xl font-bold animate-fade-in"}>{title}</div>
            <div className={"flex flex-col gap-6"}>
                <Button className={"h-12 w-64 rounded-full"} onPress={handleAction}>
                    <div className={"text-lg"} >{op}</div>
                </Button>
            </div>
        </div>
    )
}
